export enum AvatarSize {
  SMALL = 24,
  NORMAL = 32
}
